import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

function UeberUnsPage() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const px = isMobile ? '20px' : '40px';
  const py = isMobile ? '56px' : '96px';

  return (
    <>
      <Nav />

      {/* HERO */}
      <div style={{background:'#111',padding: isMobile ? '64px 20px 56px' : '88px 40px 80px'}}>
        <div style={{maxWidth:1280,margin:'0 auto'}}>
          <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'rgba(255,255,255,.4)',marginBottom:14}}>Über uns</div>
          <h1 style={{fontSize: isMobile ? 'clamp(36px,9vw,56px)' : 'clamp(48px,6vw,80px)',fontWeight:800,letterSpacing:'-2.5px',lineHeight:1.06,color:'#fff',marginBottom:20}}>
            Wir glauben,<br />dass jedes Unternehmen<br />verdient, erreichbar zu sein.
          </h1>
          <p style={{fontSize: isMobile ? 15 : 18,color:'rgba(255,255,255,.45)',lineHeight:1.7,maxWidth:580}}>FrontUp wurde nicht in einem Büro in Silicon Valley geboren. Sondern in einem Café in Braunschweig.</p>
        </div>
      </div>

      {/* GRÜNDER STORY */}
      <section style={{padding:`${py} ${px}`,background:'#fff',borderBottom:'1px solid var(--border)'}}>
        <div style={{maxWidth:1280,margin:'0 auto',display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap: isMobile ? 36 : 96,alignItems:'center'}}>
          {/* Bild oben auf Mobile */}
          {isMobile && (
            <div style={{position:'relative'}}>
              <img
                src="https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=700&h=520&fit=crop&q=85"
                style={{width:'100%',height:240,objectFit:'cover',borderRadius:14,display:'block'}}
                alt="Café"
              />
              <div style={{position:'absolute',bottom:12,left:12,right:12,background:'rgba(0,0,0,.82)',backdropFilter:'blur(8px)',borderRadius:10,padding:'12px 16px'}}>
                <div style={{fontSize:13,fontWeight:700,color:'#fff',marginBottom:2}}>Das Café meiner Eltern – Braunschweig</div>
                <div style={{fontSize:12,color:'rgba(255,255,255,.5)'}}>Seit FrontUp geht kein Anruf mehr verloren.</div>
              </div>
            </div>
          )}

          <div>
            <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:16}}>Die Geschichte</div>
            <h2 style={{fontSize: isMobile ? 'clamp(26px,6vw,38px)' : 'clamp(32px,4vw,48px)',fontWeight:800,letterSpacing:'-1.5px',lineHeight:1.1,color:'#111',marginBottom:24}}>Es begann mit einem verpassten Anruf.</h2>
            <p style={{fontSize: isMobile ? 14 : 16,color:'#666',lineHeight:1.85,marginBottom:14}}>Das Café meiner Eltern läuft seit Jahren. Gutes Essen, treue Stammgäste, eine Seele die man spürt wenn man reinkommt. Aber täglich – wirklich täglich – haben wir Anrufe verpasst. Reservierungen die nie ankamen. Kunden die woanders hingegangen sind.</p>
            <p style={{fontSize: isMobile ? 14 : 16,color:'#666',lineHeight:1.85,marginBottom:14}}>Wir hatten kein Budget für eine Empfangskraft. Und die verfügbaren KI-Lösungen? Alle wirkten wie Raumfahrttechnik – komplex, teuer, kalt.</p>
            <p style={{fontSize: isMobile ? 14 : 16,color:'#666',lineHeight:1.85,marginBottom:28}}>Also habe ich FrontUp gebaut. Für Unternehmen wie unseres. Einfach, menschlich, bezahlbar.</p>
            <div style={{display:'flex',alignItems:'center',gap:14}}>
              <div style={{width:50,height:50,background:'#111',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,fontWeight:800,color:'#fff',flexShrink:0}}>C</div>
              <div>
                <div style={{fontSize:15,fontWeight:700,color:'#111'}}>Canel Sözer</div>
                <div style={{fontSize:13,color:'#888'}}>Gründer & CEO, FrontUp</div>
              </div>
            </div>
          </div>

          {/* Bild rechts nur auf Desktop */}
          {!isMobile && (
            <div style={{position:'relative'}}>
              <img
                src="https://images.unsplash.com/photo-1559925393-8be0ec4767c8?w=700&h=520&fit=crop&q=85"
                style={{width:'100%',height:500,objectFit:'cover',borderRadius:16,display:'block'}}
                alt="Café"
              />
              <div style={{position:'absolute',bottom:20,left:20,right:20,background:'rgba(0,0,0,.82)',backdropFilter:'blur(8px)',borderRadius:12,padding:'18px 22px'}}>
                <div style={{fontSize:14,fontWeight:700,color:'#fff',marginBottom:4}}>Das Café meiner Eltern – Braunschweig</div>
                <div style={{fontSize:13,color:'rgba(255,255,255,.5)'}}>Seit FrontUp geht kein Anruf mehr verloren.</div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* PHILOSOPHIE */}
      <section style={{padding:`${py} ${px}`,background:'#f7f7f7'}}>
        <div style={{maxWidth:1280,margin:'0 auto'}}>
          <div style={{textAlign:'center',marginBottom: isMobile ? 40 : 72}}>
            <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:14}}>Unsere Philosophie</div>
            <h2 style={{fontSize: isMobile ? 'clamp(24px,6vw,36px)' : 'clamp(32px,4vw,52px)',fontWeight:800,letterSpacing:'-2px',lineHeight:1.06,color:'#111',maxWidth:720,margin:'0 auto'}}>Technologie soll dem Menschen dienen. Nicht umgekehrt.</h2>
          </div>
          <div style={{display:'grid',gridTemplateColumns: isMobile ? '1fr' : 'repeat(3,1fr)',gap: isMobile ? 12 : 2,background: isMobile ? 'transparent' : 'var(--border)',border: isMobile ? 'none' : '1px solid var(--border)',borderRadius:16,overflow:'hidden'}}>
            {[
              { n: '01', title: 'Menschlich zuerst', text: 'Unsere KI klingt nicht wie eine Maschine. Sie klingt wie jemand der sich wirklich kümmert. Warm, klar, auf Deutsch.' },
              { n: '02', title: 'Einfachheit als Prinzip', text: 'Kein Techniker. Keine wochenlange Einrichtung. Kein Vertrag. Wenn es nicht in 5 Minuten funktioniert, haben wir versagt.' },
              { n: '03', title: 'Für den Mittelstand', text: 'Wir bauen für Cafés, Handwerker, Ärzte und Makler – nicht für Konzerne. Deren Probleme kennen wir aus erster Hand.' },
            ].map(item => (
              <div key={item.n} style={{background:'#fff',padding: isMobile ? '28px 24px' : '44px 36px',borderRadius: isMobile ? 14 : 0,border: isMobile ? '1.5px solid var(--border)' : 'none'}}>
                <div style={{fontSize:28,fontWeight:800,letterSpacing:'-2px',color:'#111',marginBottom:14}}>{item.n}</div>
                <div style={{fontSize: isMobile ? 17 : 20,fontWeight:700,color:'#111',marginBottom:10}}>{item.title}</div>
                <div style={{fontSize: isMobile ? 14 : 15,color:'#888',lineHeight:1.75}}>{item.text}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* MISSION */}
      <section style={{background:'#111',padding: isMobile ? '56px 20px' : '88px 40px'}}>
        <div style={{maxWidth:960,margin:'0 auto',textAlign:'center'}}>
          <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'rgba(255,255,255,.3)',marginBottom:20}}>Unsere Mission</div>
          <p style={{fontSize: isMobile ? 'clamp(18px,5vw,26px)' : 'clamp(24px,3.5vw,40px)',fontWeight:700,color:'#fff',lineHeight:1.35,letterSpacing:'-.5px',marginBottom:36}}>„Wir wollen, dass in Deutschland kein kleines Unternehmen mehr einen Kunden verliert, weil niemand ans Telefon gegangen ist."</p>
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:12}}>
            <div style={{width:40,height:40,background:'rgba(255,255,255,.1)',borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',fontSize:16,fontWeight:800,color:'#fff',flexShrink:0}}>C</div>
            <span style={{fontSize: isMobile ? 13 : 15,color:'rgba(255,255,255,.5)'}}>Canel Sözer, Gründer FrontUp</span>
          </div>
        </div>
      </section>

      {/* WERTE */}
      <section style={{padding:`${py} ${px}`,background:'#fff'}}>
        <div style={{maxWidth:1280,margin:'0 auto'}}>
          <div style={{display:'grid',gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',gap: isMobile ? 32 : 96,alignItems:'start'}}>
            <div>
              <div style={{fontSize:12,fontWeight:700,letterSpacing:'2px',textTransform:'uppercase',color:'#111',marginBottom:16}}>Was uns antreibt</div>
              <h2 style={{fontSize: isMobile ? 'clamp(28px,7vw,40px)' : 'clamp(32px,4vw,48px)',fontWeight:800,letterSpacing:'-1.5px',lineHeight:1.1,color:'#111',marginBottom:0}}>Vier Werte.<br />Keine Kompromisse.</h2>
            </div>
            <div style={{display:'flex',flexDirection:'column',gap:0}}>
              {[
                { n: '01', title: 'Ehrlichkeit', text: 'Wir versprechen nur was wir halten können. Keine übertriebenen Marketing-Claims.' },
                { n: '02', title: 'Qualität', text: 'Lieber eine Sache richtig als zehn Sachen halbherzig. Unser Produkt muss jeden Tag besser werden.' },
                { n: '03', title: 'Nähe', text: 'Wir kennen unsere Kunden persönlich. Jede Anfrage wird von einem echten Menschen beantwortet.' },
                { n: '04', title: 'Mut', text: 'Wir denken groß. Wir wollen die Art wie kleine Unternehmen in Deutschland telefonieren für immer verändern.' },
              ].map((w, i, arr) => (
                <div key={w.n} style={{padding: isMobile ? '20px 0' : '28px 0',borderBottom: i < arr.length - 1 ? '1px solid var(--border)' : 'none',display:'flex',gap:20}}>
                  <div style={{fontSize:13,fontWeight:700,color:'#aaa',width:28,flexShrink:0,paddingTop:3}}>{w.n}</div>
                  <div>
                    <div style={{fontSize: isMobile ? 15 : 17,fontWeight:700,color:'#111',marginBottom:6}}>{w.title}</div>
                    <div style={{fontSize: isMobile ? 14 : 15,color:'#888',lineHeight:1.65}}>{w.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{background:'#111',padding: isMobile ? '56px 20px' : '88px 40px',textAlign:'center'}}>
        <div style={{maxWidth:560,margin:'0 auto'}}>
          <h2 style={{fontSize: isMobile ? 'clamp(28px,7vw,40px)' : 'clamp(36px,4.5vw,52px)',fontWeight:800,letterSpacing:'-2px',color:'#fff',marginBottom:14}}>Werde Teil der Geschichte.</h2>
          <p style={{fontSize: isMobile ? 15 : 17,color:'rgba(255,255,255,.4)',marginBottom:32,lineHeight:1.65}}>Starte heute kostenlos und erlebe selbst wie FrontUp deinen Alltag verändert.</p>
          <div style={{display:'flex',flexDirection: isMobile ? 'column' : 'row',gap:12,justifyContent:'center'}}>
            <button onClick={() => navigate('/preise')} style={{padding:'15px 28px',background:'#fff',color:'#111',border:'none',borderRadius:8,fontSize:15,fontWeight:700,fontFamily:'inherit',cursor:'pointer'}}>Ersparnis berechnen</button>
            <button onClick={() => navigate('/demo-buchen')} style={{padding:'14px 28px',background:'transparent',color:'rgba(255,255,255,.6)',border:'1.5px solid rgba(255,255,255,.2)',borderRadius:8,fontSize:15,fontWeight:600,fontFamily:'inherit',cursor:'pointer'}}>Demo buchen</button>
          </div>
        </div>
      </section>

      <Footer simple />
    </>
  );
}

export default UeberUnsPage;
